// @flow
import TokenSearcher from './TokenSearcher';
import connect from './connect';

export default connect(TokenSearcher);



// WEBPACK FOOTER //
// ./src/components/TokenSearcher/index.js